<div>
  <mat-icon>search</mat-icon>
  <span class="text1">No results found</span>
  <span class="text2">It seems we can’t find any results based on your search</span>
</div>
